import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';

import ReduxConnect from 'Demora/redux-connect';

import asyncComponent from 'Demora/AsyncComponent';

var NewCommentBox = asyncComponent(
	() =>
		import(/* webpackChunkName: "new_Comment_box" */ './Posts/NewCommentBox')
);

class ReplyTo extends Component {
	constructor() {
		super();

		this.state = {
			isOpen: false,
		};
	}

	setOpen(st) {
		let props = this.props;

		if (!props.user.id) {
			document.location = props.location.pathname;

			return;
		}

		this.setState({
			isOpen: st,
		});
	}

	render() {
		if (!this.state.isOpen) {
			return <small onClick={this.setOpen.bind(this, true)}>Reply</small>;
		}

		return (
			<div>
				<NewCommentBox
					post={this.props.comment}
					text={
						'@' + this.props.users[this.props.comment.u + '-u'].username + ' '
					}
					onSave={this.setOpen.bind(this, false)}
					focus={true}
				/>
			</div>
		);
	}
}

export default withRouter(
	ReduxConnect(ReplyTo, {
		user: 'user',
		users: 'users',
	})
);
